// extracted by mini-css-extract-plugin
export var button = "_3e7d4";
export var form = "_78774";
export var input = "_0cf81";
export var result = "_7864d";